//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// npm packages
import React from "react";

// material-ui
import CircularProgress from "@material-ui/core/CircularProgress";
import { loaderStyles } from "./style";


export default function Loader(props) {
  const classes = loaderStyles();


  return (
    <React.Fragment>
      {props.Loading ? (
        <React.Fragment>
          <div className={classes.mainDiv}>
            <CircularProgress
              className={classes.root}
            />
          </div>
        </React.Fragment>
      ) : (
        props.children
      )}
    </React.Fragment>
  );
}
